import { useGetReportingParameters } from 'api/parameters';
import { Parameter, StatRow } from 'oas';
import { getFlattenedParams } from '../utils/get-flattened-params';
import { averageNormalisedStatsPerAthlete } from '../utils/average-stats-per-athlete';
import { getMultiplier } from '../utils/get-param-multiplier';
import { normaliseStat } from '../utils/get-normalised-stat';

export const useNormaliseStats = (
    stats: StatRow[],
    additionalParams: Parameter[] = [],
    shouldUseTotalValues?: boolean,
    acRatioAverageOverride = false,
) => {
    const parameters = useGetReportingParameters();

    const flattenedParams = getFlattenedParams(parameters.data ?? []);
    const params = [...flattenedParams, ...additionalParams];
    const flattenedParamSlugs = params.map((param) => param.slug);

    const normalisedStats: StatRow[] = [];

    stats?.forEach((stat) => {
        const normalisedStat = { ...stat };
        flattenedParamSlugs?.forEach((param) => {
            const paramValue = normalisedStat[param];

            const aggregation = params.find((p) => p.slug === param)?.aggregation?.toLowerCase() ?? '';
            const groupBy = params.find((p) => p.slug === param)?.group_by?.toLowerCase() ?? '';

            normalisedStat[param] = normaliseStat(
                aggregation,
                groupBy,
                paramValue,
                getMultiplier(normalisedStat, groupBy),
            );
        });

        normalisedStats.push(normalisedStat);
    });

    return averageNormalisedStatsPerAthlete(normalisedStats, params, shouldUseTotalValues, acRatioAverageOverride);
};
